import { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { api } from '../../../config';
import { getAuthToken } from '../../../auth/tokenvalidation';
import { updateTenderOpeningStatus } from './useUpdateTenderOpeningStatus';
import {
  buildParcelFreightExportRows,
  downloadParcelFreightExcel,
} from '../utils/parcelFreightHelpers';

const useFreightRequest = ({
  procurementId,
  procurement,
  onRefreshProcurement,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isExportingExcel, setIsExportingExcel] = useState(false);

  const sendFreightRequest = async () => {
    const token = getAuthToken();
    if (!token) {
      toast.error('Authentication required. Please login again.');
      return false;
    }

    setIsSubmitting(true);
    try {
      await axios.put(
        `${api.API_URL}/procurement/send-request-freight-availability/${procurementId}`,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      await updateTenderOpeningStatus(
        procurementId,
        'isReqFreightAvailabilityCompleted'
      );

      toast.success('Freight availability request sent successfully.');
      onRefreshProcurement?.();
      return true;
    } catch (err) {
      const message =
        err?.response?.data?.message ||
        err?.message ||
        (typeof err === 'string'
          ? err
          : 'Failed to send freight availability request.');
      toast.error(message);
      return false;
    } finally {
      setIsSubmitting(false);
    }
  };

  const exportParcelFreightToExcel = parcels => {
    const rows = buildParcelFreightExportRows(parcels);
    if (!rows.length) {
      toast.error('No FOB incoterm data available to export.');
      return false;
    }

    setIsExportingExcel(true);
    try {
      downloadParcelFreightExcel(rows, {
        procurementNumber: procurement?.procurementNumber,
        submittedDate: procurement?.submittedDateTenderOpening,
      });
      return true;
    } catch (error) {
      toast.error(error?.message || 'Failed to export parcel data to Excel.');
      return false;
    } finally {
      setIsExportingExcel(false);
    }
  };

  return {
    isSubmitting,
    sendFreightRequest,
    exportParcelFreightToExcel,
    isExportingExcel,
  };
};

export default useFreightRequest;
